export const getOptimalFirstColumnWidth: (text: string) => number = (text: string) => {
  const baseCharWidth = 9; // Average character width in pixels
  const padding = 16; // Additional padding
  const minWidth = 60; // Minimum width
  const maxWidth = 300; // Maximum width to prevent overly wide columns

  let calculatedWidth = text.length * baseCharWidth + padding;

  const lines = text.split('\n');
  if (lines.length > 1) {
    const longestLine = lines.reduce((longest, current) => (current.length > longest.length ? current : longest), '');
    calculatedWidth = longestLine.length * baseCharWidth + padding;
  }

  calculatedWidth = Math.max(minWidth, Math.min(maxWidth, calculatedWidth));

  return calculatedWidth;
};
